
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`91,6%, selon les résultats préliminaires des essais de phase III, publiés le 2
février dans le
`}<a parentName="p" {...{
        "href": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00234-8/fulltext"
      }}>{`Lancet`}</a>{`.`}</p>
    <p>{`Selon l'agence Reuters, le ministre russe de la Santé a précisé le 11 août 2021
que l'efficacité contre le variant Delta était d'environ 83%. Quelques jours
plus tard, le directeur de l'institut Gamaleya a déclaré qu'un produit modifié
avait été élaboré. Selon lui, il était trop tôt pour parler du niveau
d'efficacité.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;